import {
  IncomeDTO,
  IncomeFrequency,
  IncomeModel,
  IncomeType,
  OwnerModelDTO,
} from '../../api/useIncomeQuery';
import { getDefaultCustomBucketIndex } from '../../utils/getDefaultCustomBucketIndex';

export interface UpsertIncomeDTO extends EmploymentFormValues {
  clientId: string;
  id: string | null;
  incomeType: IncomeType;
}

export interface EmploymentFormValues {
  Name: string;
  Earner: string;
  Amount: number | null;
  Inflation: number | null;
  IncomeFrequency: IncomeFrequency | null;
  YearlyTaxableAmount: number | null;
  BonusCommissions: number | null;
  StartAge: number | null | undefined;
  EndAge: number | null | undefined;
  EndAtRetirement: boolean | null;
  IsTaxFree: boolean | null;
  SelfEmployed: boolean | null;
  OrionManagementStyleId: number | null;
  CustomBucketIndex: number | null;
  OwnerModel: OwnerModelDTO[];
}

const defaultValues = {
  Name: '',
  Amount: null,
  Inflation: null,
  IncomeFrequency: IncomeFrequency.Yearly,
  YearlyTaxableAmount: null,
  BonusCommissions: null,
  StartAge: undefined,
  EndAge: undefined,
  EndAtRetirement: false,
  IsTaxFree: false,
  SelfEmployed: false,
  OrionManagementStyleId: null,
  CustomBucketIndex: null,
};

export const dataToForm = (income: IncomeModel | null, data: IncomeDTO): EmploymentFormValues => {
  const { Options: options } = data;

  if (!income) {
    return {
      ...defaultValues,
      Earner: options.OwnerOptions.People[0].Name,
      OwnerModel: [
        {
          Id: null,
          Name: options.OwnerOptions.People[0].Name,
          OwnerType: 0,
          Percentage: 1,
        },
      ],
    };
  }

  return {
    ...income,
    IncomeFrequency:
      income.IncomeFrequency !== null ? income.IncomeFrequency : IncomeFrequency.Yearly,
    EndAge: income.EndAtRetirement ? null : income.EndAge ? income.EndAge : undefined,
    CustomBucketIndex: getDefaultCustomBucketIndex({
      isAssetBucketingByManagementStyle: options.AssetBucketingByManagementStyle,
      customBucketIndex: income.CustomBucketIndex,
      orionManagementStyleId: income.OrionManagementStyleId,
      managementStylesOptions: options.ManagementStyles,
    }),
  };
};
